export const CROP_PANEL_TOOLTIPS = [
  {
    id: 'crop-tool',
    cookieKey: 'editor_tip_crop_tool',
    title: 'Crop',
    description:
      'Drag the cursor over the image to select the area that will be cropped and click Apply Crop.',
    placement: 'top',
    align: 'center',
    delayAfterClose: 1800,
  },
];
